@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/global.variables' as globalVariables;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/spacing.variables' as spacing;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/colours.variables' as colours;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/fonts.variables' as fonts;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/2-tools/placeholder/focus.placeholders' as
	focusPlaceholders;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/font-sizes.variables' as fontSizes;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/4-elements/_global.elements.scss';
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/7-overrides/_visibility.overrides.scss';

@use '../../styles/fieldsets.scss';
@use '../../styles/labels.scss';
@use '../../styles/text-inputs.scss';
@forward '../../utils/components/error-message/error-message';

$ontario-input-padding: 0.625rem;
$ontario-input-border-width: 0.125rem;

.ontario-input {
	border: globalVariables.$border-size-standard solid colours.$ontario-colour-black;
	border-radius: globalVariables.$global-radius;
	box-sizing: border-box;
	color: colours.$ontario-colour-black;
	display: block;
	font-size: fontSizes.$ontario-font-size-standard-body-text;
	font-family: fonts.$ontario-font-open-sans;
	line-height: globalVariables.$line-height-default;
	margin: spacing.$spacing-0;
	max-width: globalVariables.$standard-width;
	padding: $ontario-input-padding spacing.$spacing-4;
	transition: focusPlaceholders.$ontario-focus-transition;
	width: globalVariables.$full-width;

	&:focus,
	&:active {
		@extend %ontario-focus !optional;
	}
}

.ontario-input-hint-expander--true {
	margin-bottom: spacing.$spacing-4;
}

.ontario-input--2-char-width {
	max-width: 8ex;
}

.ontario-input--3-char-width {
	max-width: 10ex;
}

.ontario-input--4-char-width {
	max-width: 12ex;
}

.ontario-input--5-char-width {
	max-width: 14ex;
}

.ontario-input--7-char-width {
	max-width: 17ex;
}

.ontario-input--10-char-width {
	max-width: 23ex;
}

.ontario-input--20-char-width {
	max-width: 41ex;
}

.ontario-input--error {
	input {
		border: $ontario-input-border-width solid colours.$ontario-colour-alert;
	}
}
